import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=7a70d21f&scoped=true"
import script from "./reportDetail.vue?vue&type=script&lang=js"
export * from "./reportDetail.vue?vue&type=script&lang=js"
import style0 from "./reportDetail.vue?vue&type=style&index=0&id=7a70d21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70d21f",
  null
  
)

export default component.exports